export const fontWeights = {
    NORMAL: "normal",
    MEDIUM: "500",
    SEMI_BOLD: "600",
    BOLD: "bold",
    EXTRA_BOLD: "800",
};
